/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaching_Template_SaveInputs */

const en_us2_coaching_template_save = /** @type {(inputs: Coaching_Template_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save template`)
};

const pt_br2_coaching_template_save = /** @type {(inputs: Coaching_Template_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvar modelo`)
};

const pt_pt2_coaching_template_save = /** @type {(inputs: Coaching_Template_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvar modelo`)
};

/** @type {(inputs: Coaching_Template_SaveInputs) => LocalizedString} */
const es_419_coaching_template_save = en_us2_coaching_template_save;

/** @type {(inputs: Coaching_Template_SaveInputs) => LocalizedString} */
const fr_fr2_coaching_template_save = en_us2_coaching_template_save;

/** @type {(inputs: Coaching_Template_SaveInputs) => LocalizedString} */
const de_de2_coaching_template_save = en_us2_coaching_template_save;

/** @type {(inputs: Coaching_Template_SaveInputs) => LocalizedString} */
const it_it2_coaching_template_save = en_us2_coaching_template_save;

/**
* | output |
* | --- |
* | "Save template" |
*
* @param {Coaching_Template_SaveInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coaching_template_save = /** @type {((inputs?: Coaching_Template_SaveInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_Template_SaveInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coaching_template_save(inputs)
	if (locale === "es-419") return es_419_coaching_template_save(inputs)
	if (locale === "pt-PT") return pt_pt2_coaching_template_save(inputs)
	if (locale === "fr-FR") return fr_fr2_coaching_template_save(inputs)
	if (locale === "de-DE") return de_de2_coaching_template_save(inputs)
	if (locale === "it-IT") return it_it2_coaching_template_save(inputs)
	return en_us2_coaching_template_save(inputs)
});
export { coaching_template_save as "coaching.template_save" }